import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {EntityType, ExampleDocumentResponse} from '../domains/common.domain';
import {EnvironmentService} from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadCenterService {

  baseUrl: string;

  constructor(
    private httpClient: HttpClient,
    private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.apiUrl;
  }

  getAllData(type: string): Observable<any> {
    if (type === 'documents') {
      return this.httpClient.get(this.baseUrl + 'downloadcenter');
    } else if (type === 'areas') {
      return this.httpClient.get(this.baseUrl + 'regionalstructure/devarea');
    }
  }

  uploadDocument(event: any, name: string): Observable<any> {
    const formData = new FormData();
    formData.append('document', event.currentFiles[0]);
    formData.append('name', name);
    return this.httpClient.post(this.baseUrl + 'downloadcenter', formData);
  }

  removeEntity(entityType: string, id: string): Observable<any> {
    if (entityType === EntityType.Document) {
      return this.httpClient.delete(this.baseUrl + 'downloadcenter?document_id=' + id);
    } else if (entityType === EntityType.Area) {
      return this.httpClient.delete(this.baseUrl + 'regionalstructure/devarea?area_id=' + id);
    }
  }

  readDocument(id: string): Observable<any> {
    return this.httpClient.get(this.baseUrl + 'downloadcenter/download?document_id=' + id, {responseType: 'blob'});
  }

  downloadDocument(response: Blob, fileName: string): void {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base: string = atob(reader.result.toString().split(',')[1]);
      const downloadLink = document.createElement('a');
      downloadLink.href = 'data:application/octet-stream;base64,' + base;
      downloadLink.download = fileName;
      downloadLink.click();
    };
    reader.readAsDataURL(response);
  }

  addNewArea(reqObj: any): Observable<any> {
    return this.httpClient.post(this.baseUrl + 'regionalstructure/devarea', reqObj);
  }

  modifyArea(reqObj: any, areaId: string): Observable<any> {
    return this.httpClient.put(this.baseUrl + 'regionalstructure/devarea?area_id=' + areaId, reqObj);
  }

  updateLookUp(lang: string): Observable<any> {
    return this.httpClient.get(this.environmentService.apiUrl + `lookup_properties/${lang}`);
  }

  getExampleDocumentById(documentId: string): Observable<any> {
    return this.httpClient.get(this.baseUrl + 'exampledoc/download?document_id=' + documentId, {responseType: 'blob'});
  }

  getAllExampleDocuments(): Observable<ExampleDocumentResponse> {
    return this.httpClient.get<ExampleDocumentResponse>(this.baseUrl + 'exampledoc');
  }

  uploadExampleDocument(event: any, documentType: string, name: string): Observable<any> {
    const formData = new FormData();
    formData.append('document', event.currentFiles[0]);
    formData.append('name', name);
    formData.append('sk_document_type', documentType);
    return this.httpClient.post(this.baseUrl + 'exampledoc', formData);
  }

  deleteExampleDocument(documentId: string): Observable<any> {
    return this.httpClient.delete(this.baseUrl + 'exampledoc?document_id=' + documentId);
  }
}
